import { render, staticRenderFns } from "./ErrorReportButton.vue?vue&type=template&id=08200bd0"
import script from "./ErrorReportButton.vue?vue&type=script&lang=js"
export * from "./ErrorReportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports